import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { BRAND_NAME, BRAND_URL } from 'utils/constants';

/**
 * Both modes point at the same artwork on purpose: the mark is charcoal on
 * transparent, and dark mode re-tones it with `--dc-logo-filter` rather than
 * maintaining a parallel set of files. Knockout details invert correctly --
 * white-inside-dark becomes dark-inside-light, which is what a dark ground
 * wants.
 */
const logoMap = {
  default: { dark: '/dh-icons/logo.svg', light: '/dh-icons/logo.svg' },
  tagline: {
    dark: '/dh-icons/DCLogoWTagline.svg',
    light: '/dh-icons/DCLogoWTagline.svg',
  },
};

const ThemedLogo = ({ variant = 'default', href = BRAND_URL, ...boxProps }) => {
  const theme = useTheme();
  const mode = theme.palette.mode === 'dark' ? 'dark' : 'light';
  const src = logoMap[variant]?.[mode] || logoMap.default[mode];

  return (
    <Box
      display={'flex'}
      component="a"
      href={href}
      title={BRAND_NAME}
      {...boxProps}
    >
      <Box
        component={'img'}
        src={src}
        height={1}
        width={1}
        sx={{ filter: 'var(--dc-logo-filter)' }}
      />
    </Box>
  );
};

ThemedLogo.propTypes = {
  variant: PropTypes.oneOf(['default', 'tagline']),
  href: PropTypes.string,
};

export default ThemedLogo;
